/**
 * meltofswiterzland.com 2023
 *
 * Skripte für die Webseite.
 *
 * @author Andreas Tschan - Tschan ITS
 * @version 1.0
 */

window.addEventListener("load", (event) => {
  preloadImages();
});

/**
 * Preload Bilder.
 *
 * @version 1.0.0
 */
function preloadImages(): void {
  const imagesPath = "/assets/img/";

  const images: string[] = [
    `${imagesPath}logo_large.jpg`,
    `${imagesPath}logo_medium.jpg`,
    `${imagesPath}logo_small.jpg`,
    `${imagesPath}showcase/praline01_300Px.jpg`,
    `${imagesPath}showcase/praline01_600Px.jpg`,
    `${imagesPath}showcase/praline01_900Px.jpg`,
  ];

  images.forEach((image) => {
    let domImg = new Image();
    domImg.src = image;
  });
}
